import CiroDropDown from "../shared/CiroDropdown";
import CiroFilterModalDropdownSection from "../shared/CiroFilter/CiroFilterModalDropdownSection";

const ScoringCriteriaFilter = ({
  scoringCriteria,
  setScoringCriteriaFilter,
  scoringCriteriaFilter,
}: {
  scoringCriteria: { id: number; label: string }[];
  setScoringCriteriaFilter: (v: string[]) => void;
  scoringCriteriaFilter: string[];
}) => {
  const filterOptions = scoringCriteria.map((scoringCriterion) => {
    return {
      label: scoringCriterion.label,
      filter: (
        <CiroDropDown
          options={[
            {
              value: `${scoringCriterion.id}_matches`,
              label: "Matches",
            },
            {
              value: `${scoringCriterion.id}_does_not_match`,
              label: "Does not match",
            },
            {
              value: `${scoringCriterion.id}_unknown`,
              label: "Unknown",
            },
          ]}
          value={scoringCriteriaFilter.filter(
            (filter) =>
              filter === `${scoringCriterion.id}_matches` ||
              filter === `${scoringCriterion.id}_does_not_match` ||
              filter === `${scoringCriterion.id}_unknown`,
          )}
          onChange={(newValue) => {
            const criterionId = scoringCriterion.id;
            const existingFilters = scoringCriteriaFilter.filter(
              (f) => !f.startsWith(`${criterionId}_`),
            );
            setScoringCriteriaFilter([...existingFilters, ...newValue]);
          }}
          isMulti={true}
        />
      ),
    };
  });

  return (
    <CiroFilterModalDropdownSection
      numFiltersApplied={scoringCriteriaFilter.length}
      sectionTitle="Scoring criteria"
      filterOptions={filterOptions}
    />
  );
};

export default ScoringCriteriaFilter;
